import React from "react";
import CurriculumHeader from "components/header/CurriculumHeader";

const Curriculum = () => {
  return (
    <div className="flex flex-col justify-center gap-4 xl:gap-10 xl:mx-24 mt-10">
      <CurriculumHeader
        title="ԱԶԳԱՅԻՆ ԿՐԹԱԿԱՐԳԻ"
        sectionTitle="ՆԱԽԱԲԱՆ"
        buttonTitle="Բովանդակություն"
        buttonLink="/national-curriculum/content"
      />
      <div class="p-6 xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]">
        <h3 class="text-[#493ED3] font-noto-sans-armenian text-[24px] font-semibold leading-normal mb-4">
          Նախաբան
        </h3>
        <p className="text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Ազգային կրթակակարգում ներառված են քաղաքակրթական հիմքի վրա ազգային
          կրթական քաղաքականության, դաստիարակության, ուսուցման, ուսումնառության և
          գնահատման ընդհանուր սկզբունքները:
        </p>
        <p className="text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Ազգային կրթակարգի ստեղծմամբ հռչակվում է «Ազգային դպրոցի» (առայժմ՝
          վիրտուալ միջավայրում գործող) հիմնարար նպատակը․ 21-րդ դարի առաքինի
          քաղաքացու՝ «Արարատյան Մարդու» կայացման համար կրթական և դաստիարակչական
          գործառույթների լիարժեք ներդաշնակում` «Ազգային ուսուցչի» բացառիկ
          պատասխանատվությամբ և դերակատարությամբ։ Ազգային ինքնության, մշակութային
          ժառանգության պահպանության, արդիականացման, փոխանցման և 21-րդ դարի
          պահանջներին համապատասխան կրթական տեղեկատվության ապահովման միջոցով՝
          առաքինի, մասնագիտական և ֆունկցիոնալ գրագետ քաղաքացու ձևավորումն է։
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Ազգային կրթակարգի ստեղծումը թելադրված է․
        </p>
        <ul className="ml-4 list-disc pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            21-րդ դարում ազգային քաղաքակրթական արժեքների արդիականացման և
            սերունդներին փոխանցման հրամայականով,
          </li>
          <li>
            Ազգային հանրակրթական համակարգը քաղաքակրթական հիմքի վրա միջազգայնորեն
            ընդունված չափանիշներին համապատասխանեցնելու հրամայականով,
          </li>
          <li>
            ՀՀ հանրակրթական համակարգում իրականացվող բարեփոխումների կրթական և
            ազգային դաստիարակության անորոշության պարտադրանքով,
          </li>
          <li>
            Հանրակրթական համակարգում նորագույն տեխնոլոգիաների կիրառման
            անփոխարինելության անհրաժեշտության հրամայականով։
          </li>
        </ul>
        <p class="text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Ազգային կրթակարգն անհրաժեշտ է «Ազգային դպրոցի» (առայժմ՝ վիրտուալ
          միջավայրում գործող) կրթադաստիարակչական գործունեությունը կազմակերպելու
          համար։ Այն լրացնելու է հանրակրթության պետական կրթակարգում առկա
          կրթական, դաստիարակչական և տեխնոլոգիական բացերը։ Կրթակարգն անհրաժեշտ է
          կրթական գործընթացի բոլոր կողմերին՝ ուսուցիչներին, աշակերտներին,
          կրթությունը կազմակերպող պետական կառավարման ու տեղական ինքնակառավարման
          մարմիններին, հանրակրթական դպրոցներին և կրթություն իրականացնող մյուս
          հաստատություններին` Ազգային կրթակարգով սահմանված ընդհանուր նպատակներին
          հասնելու համար:
        </p>
      </div>
    </div>
  );
};

export default Curriculum;
